import { pressHandlers } from "./press-handlers";

export function ChatButton({
  unread,
  onOpen,
}: {
  unread: number;
  onOpen: () => void;
}) {
  const handlers = pressHandlers(onOpen);
  return (
    <button
      className="chat-button"
      aria-label={unread ? `Чат · непрочитанных: ${unread}` : "Чат"}
      onClick={handlers.onClick}
      onPointerDown={(event) => {
        if (event.button === 0)
          event.currentTarget.focus({ preventScroll: true });
        handlers.onPointerDown(event);
      }}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
      >
        <path d="M4 4h16v12H9l-5 4V4Z" />
        <path d="M8 8h8M8 12h5" />
      </svg>
      {unread > 0 && (
        <i>
          {Math.min(unread, 99)}
          {unread > 99 ? "+" : ""}
        </i>
      )}
    </button>
  );
}
